import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from './auth'
import { SessionKeys } from './AppUtils'
import CONFIG from './config'

export const RequireAuth = ({ children }) => {
  const location = useLocation()
  const auth = useAuth()

  console.log('USER 1', auth.user, location)
  if (!localStorage.getItem(SessionKeys.API_TOKEN_BROKER)) {

    // CHECK IF SUBDOMAIN
    const domainArray = window.location.host.split('.');
    const subDomain = domainArray[0];

    if (subDomain !== CONFIG.SUB_DOMAIN_NAME && !subDomain.includes('localhost')) {
      console.log('USER', auth.user, location)
      localStorage.setItem(SessionKeys.LOGIN_COMPANY, subDomain)
      const locationPath = { path: location.pathname, query: location.search, company: subDomain };
      localStorage.setItem(SessionKeys.LOCATION_PATH_REDIRECT, JSON.stringify(locationPath));
      let path = locationPath.path;
      // if (path[path.length - 1] == "/") path = path.slice(0,-1)
      return <Navigate to={`/login`} state={locationPath} />
    } 
    // else if (subDomain == CONFIG.SUB_DOMAIN_NAME) {
    //   // localStorage.setItem(SessionKeys.LOGIN_COMPANY, subDomain)
    //   // alert('hello')
    //   const locationPath = { path: location.pathname, query: location.search, company: subDomain };
    //   localStorage.setItem(SessionKeys.LOCATION_PATH_REDIRECT, JSON.stringify(locationPath));
    //   return <Navigate to={`/`} state={locationPath} />
    // }
    return children
  }
  
  return children
}